import React from 'react';
import Icon from '../Icon/Icon';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
`;

const Label = styled.div`
  display: inline-block;
`;

const HelpIconContainer = styled.div`
  display: inline-block;
  position: relative;
`;

const HelpIcon = styled(Icon)`
  margin-left: 5px;
  height: 15px;
  width: 15px;
  vertical-align: 0;
`;

const Tooltip = styled.div`
  background: #f9e7cc;
  border-radius: 4px;
  padding: 10px;
  position: absolute;
  top: 0;
  left: 40px;
  width: 300px;
  z-index: 100;
`;


class LabelHint extends React.Component {

  state = {
    open: false
  };

  render() {
    return (<Container>
      <Label>{this.props.children}</Label>
      <HelpIconContainer>
        <HelpIcon onMouseOver={ () => { this.setState({ open: true })} }
              onMouseOut={ () => { this.setState({ open: false })} }
              name="hint"
              inline
        />
        { this.state.open && <Tooltip>{this.props.hint}</Tooltip> }
      </HelpIconContainer>
    </Container>)
  };
}

export default LabelHint;



// WEBPACK FOOTER //
// ./src/components/LabelHint/index.js